<template>
  <div>
    <label class="mb-3">
      {{ index }}.
      {{ question }}
    </label>
    <b-link v-if="questionPlan" class="d-flex mb-3" @click="showModal">
      <i class="material-icons align-self-center small mx-1">
        flag
      </i>
      Click to see your plan
    </b-link>
    <b-input-group class="mb-3">
      <b-form-input
        id="input-time"
        v-model="value"
        type="text"
        placeholder="HH:MM"
        :required="required"
      ></b-form-input>
      <b-input-group-append>
        <b-form-timepicker
          hide-header
          v-model="value"
          button-only
          right
          locale="en"
          aria-controls="input-time"
        ></b-form-timepicker>
      </b-input-group-append>
    </b-input-group>
    <modal :Gid="id" :planAnswers="getRelatedPlanAnswers" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import mixinListenerChangeElement from '@/mixins/listenerChangeElement';
import modal from '@/components/practice/modalQuestionPlan.vue';

export default {
  components: {
    modal,
  },
  props: {
    question: String,
    index: Number,
    id: Number,
    answers: Array,
    questionPlan: Number,
    required: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [mixinListenerChangeElement],
  computed: {
    ...mapGetters('planning', ['getRelatedPlanAnswers']),
    ...mapGetters('user', ['getUserId']),
  },
  data() {
    return {
      value: '',
      modalQuestion: false,
    };
  },
  methods: {
    ...mapActions('planning', ['FetchRelatedPlanAnswers']),
    showModal() {
      this.FetchRelatedPlanAnswers({
        parent: this.getUserId,
        questions: [this.questionPlan],
      }).then((response) => {
        this.modalQuestion = true;
        console.log('Response', response);
      });
    },
  },
  mounted() {
    if (this.answers != null && this.answers.length != 0) {
      this.tableRows = [];
      this.answers.forEach((element) => {
        this.value = element.answer_text_1;
      });
    }
  },
};
</script>
